/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Row, Col } from "react-awesome-styled-grid";
import { Link } from "react-router-dom";
import { Spacer, Text } from "@nordcloud/gnui";
import styles from "~/assets/styles/Runbook.module.css";
import { Divider } from "~/components/Styled/Divider";
import { Application } from "~/models";
import { ROUTES } from "~/routing";
import { displayEnumValue } from "~/tools/display/displayEnumValue";

type Props = {
  application: Application;
};

function Environments({ application }: Props) {
  return (
    <Divider>
      <Spacer height="1rem" />

      <Row>
        <Col lg={12}>
          <Text isTitle weight="medium">
            Environments
          </Text>

          {application?.environments?.length < 1 ? (
            <Text mt={3}>No Environments</Text>
          ) : (
            <>
              <div className={styles.columnsContainer}>
                <span className={styles.tableHeader}>Environment</span>
                <span className={styles.tableHeader}>Type</span>
                <span className={styles.tableHeader}>Status</span>
                <span className={styles.tableHeader}>Service Level</span>
              </div>
              {application.environments?.map((environment, index) => (
                <div key={index} className={styles.columnsContainer}>
                  <Link
                    className={styles.tableElement}
                    to={`${ROUTES.customers.index}/${application.customer.id}/${application.id}/${environment.id}`}
                  >
                    {environment?.name}
                  </Link>
                  <p className={styles.tableElement}>
                    {displayEnumValue(environment?.type)}
                  </p>
                  <p className={styles.tableElement}>
                    {displayEnumValue(environment?.status)}
                  </p>
                  <p className={styles.tableElement}>
                    {environment?.attachedServiceLevel?.serviceLevel?.name}
                  </p>
                </div>
              ))}
            </>
          )}
        </Col>
      </Row>
      <Spacer height="1rem" />
    </Divider>
  );
}

export { Environments };
